import "./index.less"
import { groupParamsByKey, gaProductDetailDataLayer, } from '@utils/index.js'
import {shopifyCartAdd} from '@utils/api.js';

if (!customElements.get('jky-sticky-cart')) {
    customElements.define('jky-sticky-cart', class JkyStickyCart extends HTMLElement {
      constructor() {
        super();

        // url链接，携带的【产品推荐】标签
        this.recommendedTag = getUrlQueryParams('action_tag') || ''
      }
      connectedCallback() {
        // 4.0 粘性购物车
        if(window?.pageInfo?.template?.startsWith("product")) {
          const dom = document.querySelector("jky-sticky-cart")
          window.addEventListener('scroll', () => {
            const scroll = window.scrollY
            if(scroll > 250 && !dom.classList.contains('active')) {
              if (!this._initialized) {
                this._initialized = true
                this.init()
              }
              dom.classList.add('active')
            }
            if(scroll <= 250 && dom.classList.contains('active')) {
              dom.classList.remove('active')
            }
          })
        }
      }

      init() {
        this.select_id = Number(this.getAttribute("init-variant-id"));
        this.open_tax_free_popup_before_buy = this.getAttribute("init-current-tax-free-popup") == "true"
        this.addButton = this.querySelector('#sticky_addToCart');
        this.variantsButtons = this.querySelectorAll(".list-menu--disclosure li");
        this.skuDetails = this.querySelector("details-disclosure details");
        this.product_variantwrap = document.querySelector(".variant-input-wrap,variant-fields");

        this.enable_shortage_reminds = this.getAttribute("enable_shortage_reminds") === "true"
        this.addButton_dom = this.querySelector('.sticky_cart_addToCart');
        this.shortage_dom = this.querySelector('.shortage-btn');

        this.updateMasterId();

        for(let i = 0; i < this.variantsButtons.length; i++) {
          const target = this.variantsButtons[i];
          target.addEventListener("click", this.onVariantChange.bind(this))
        }
        
        // main-product 触发粘性购物车variant变化
        if(!document.querySelector("variant-fields")) {
          if(this.product_variantwrap) {
            let this_ = this;
            $(this.product_variantwrap).find("label").click(function() {
              const id = $(this).attr("data-product-label");
              $(this_.skuDetails).find(`li[data-id='${id}']`).trigger('click');
            })
          }
        }

        // this.addButton.addEventListener("click", (e) => {
        //   if(!document.querySelector("button[name='add']")) return
        //   gaProductDetailDataLayer({
        //     "product_spu_name": this.getAttribute('product-title'), //识别页面产品spu标题名称text
        //     "module": "Parameter", //固定名称Parameter
        //     "options": this.currentVariant?.title, //主体产品sku文本text。
        //     "button_name": e.target.innerText, // 按钮名称文本text
        //   })
        //   document.querySelector("button[name='add']").click()
        // })
        this.addButton && this.addButton.addEventListener("click", (e) => {
          if (this.addButton.classList.contains('loading')) return;
          if (this.open_tax_free_popup_before_buy) {
            try {
              document.querySelector('product-form')?.showTaxFreePopup(() => this.addToCart(e, this.select_id, 1))
            } catch (err) {
              this.addToCart(e, this.select_id, 1)
            }
          } else {
            this.addToCart(e, this.select_id, 1)
          }
        })

        if (this.shortage_dom) {
          this.shortage_dom.addEventListener("click", () => this.handleShortageClick())
        }

        this.initStatus();

        // 有多个变体，监听 details open。单个变体时，没有渲染details-disclosure组件
        if (this.querySelector('details-disclosure')) {
          this.querySelector('details-disclosure').handleOpen = () => {
            const ulDOM = this.skuDetails?.querySelector('ul')
            const variantTitle = this.skuDetails.querySelector('summary').querySelector('.variant-title')

            const variantTitleWidth = variantTitle.getBoundingClientRect().width + 15

            if (variantTitleWidth < ulDOM.getBoundingClientRect().width) {
              ulDOM.style.left = 0
              ulDOM.style.right = 'unset'
            } else {
              ulDOM.style.left = variantTitleWidth - ulDOM.getBoundingClientRect().width + 'px'
              ulDOM.style.right = 'unset'
            }

            // 查找 .active 元素并滚动到其位置
            const activeElement = ulDOM.querySelector("li.active");
            if (activeElement) {
              activeElement.scrollIntoView({ behavior: "smooth", block: "center" });
            }

            // 数据埋码
            gaProductDetailDataLayer({
              "product_spu_name": this.getAttribute('product-title'), //识别页面产品spu标题名称text
              "module": "Bottom Cart", //固定名称Bottom Cart
              "options": this.currentVariant?.title, //主体产品sku文本text
              "type": "open", // 仅记录展开，固定命名open。
            })
          }
        }
      } 

      handleShortageClick() {
        if(document.querySelector("product-shortage")) {
          document.querySelector("product-shortage").bindEvents()
        }

        if(document.querySelector(".shortage_popup details")) {
          document.querySelector(".shortage_popup details").setAttribute("open", true)
        }
      }

      onVariantChange(e) {
        const target = e.target
        this.open_tax_free_popup_before_buy = target.dataset.taxFreePopup == "true"
        const isSoldout = target.hasAttribute("disabled");
        if (this.addButton.classList.contains("loading")) return;

        if(target.classList.contains("active")) return

        this.updateOptions(target);
        this.updateMasterId();
        this.updateProductInfo();

        this.skuDetails && this.skuDetails.removeAttribute("open");
        // change url variant
        const url = new URL(window.location);
        url.searchParams.set("variant", this.select_id);
        // 携带 产品推荐 标签
        if (this.recommendedTag) {
          url.searchParams.set("action_tag", this.recommendedTag);
        }
        window.history.pushState({}, "", url);
        
        // dispatch variant change
        if(document.querySelector("variant-fields") && this.currentVariant) { // 新商品详情
          document.querySelector("variant-fields").onVariantChange(this.currentVariant.id)
        } else {  
          try {
            const input_selected_variant = this.product_variantwrap.querySelector(`input[value='${this.select_id}']`)
            if(input_selected_variant) {
              input_selected_variant.checked = true;
              $(input_selected_variant).trigger('change');
            }
          } catch (error) {
            console.error(error)
          }
        }
        
        this.updateCartBtn(isSoldout);
      }

      updateCartBtn(isSoldout) {
        if(isSoldout) {
          if(this.enable_shortage_reminds) {
            this.addButton_dom.classList.add("hide")
            this.shortage_dom.classList.remove("hide")
          } else {
            this.addButton.classList.add("disabled");
            this.addButton.innerText = window.pageInfo.strings.product.soldOut;
          }
        } else {
          if(this.enable_shortage_reminds) {
            this.shortage_dom.classList.add("hide");
          }
          // if(this.enable_shortage_reminds) {
          //   this.addButton_dom.classList.remove("hide")
          //   this.shortage_dom.classList.add("hide")
          // } else {
          //   this.addButton.classList.remove("disabled");
          //   this.addButton.innerText = window.pageInfo.strings.product.addToCart;
          // }
          this.addButton_dom.classList.remove("hide");
          this.addButton.classList.remove("disabled");
          this.addButton.innerText = window.pageInfo.strings.product.addToCart;
        }
      }

      updateOptions(target) {
        this.select_id = Number(target.getAttribute("data-id"))
        Array.from(this.querySelectorAll('.list-menu--disclosure li'), (variant) => {
          variant.classList.remove("active")
          if(Number(variant.getAttribute("data-id")) === this.select_id) {
            variant.classList.add("active")
          }
        });
      }
      
      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant, index) => {
          return variant.id === this.select_id
        });
      }

      updateProductInfo() {
        // const pImg = this.querySelector(".sticky_cart_productImg")
        // const pTitle = this.querySelector(".sticky_cart_title")
        const pPrice = this.querySelector(".sticky_cart_price")
        const oPrice = this.querySelector(".product--originPrice")
        const dPrice = this.querySelector(".product-price--discount_amount")
        const variant_title = this.querySelector(".variant-title")
        if (!this.currentVariant) return;
        // if (this.currentVariant.featured_image) {
        //   pImg.src = this.currentVariant.featured_image.src
        //   pImg.alt = this.currentVariant.title
        // }

        // pTitle.innerText = this.currentVariant.title
        variant_title.innerText = this.currentVariant.title
        pPrice.innerText = formatMoney(this.currentVariant.price, window.pageInfo.currency.money_format)

        if (oPrice) {
          if (this.currentVariant.compare_at_price > this.currentVariant.price) {
            oPrice.innerText = formatMoney(this.currentVariant.compare_at_price, window.pageInfo.currency.money_format)
            oPrice.style.display = 'block'
          } else {
            // 显示会员价
            const variant = window.productMemberPriceInfo?.find(item => item.id == this.currentVariant.id)
            if (window.pageInfo?.customerInfo?.id && variant) {
              oPrice.style.display = 'block'
            } else {
              oPrice.style.display = 'none'
            }
          }
        }
        if (dPrice) {
          if (this.currentVariant.compare_at_price > this.currentVariant.price) {
            const dis_amount = Math.floor((this.currentVariant.compare_at_price - this.currentVariant.price) / 100) * 100
            let money_format = window?.pageInfo?.currency?.money_format?.replace('{{amount}}', '{{amount_no_decimals}}')
            money_format = money_format?.replace('{{amount_with_comma_separator}}', '{{amount_no_decimals_with_comma_separator}}')
            const discountPrice = formatMoney(dis_amount, money_format)
            dPrice.innerText = dPrice.dataset.format.replace('()', discountPrice)
            dPrice.style.display = 'block'
          } else {
            // 显示会员价
            const variant = window.productMemberPriceInfo?.find(item => item.id == this.currentVariant.id)
            if (window.pageInfo?.customerInfo?.id && variant) {
              dPrice.style.display = 'block'
            } else {
              dPrice.style.display = 'none'
            }
          }
        }

        // 数据埋码
        gaProductDetailDataLayer({
          "product_spu_name": this.getAttribute('product-title'), //识别页面产品spu标题名称text
          "module": "Bottom Cart", //固定名称Bottom Cart
          "options": this.currentVariant?.title, //选择后的产品名称，主体产品sku文本text。
          "type": "choose", // 记录筛选后的产品，固定命名choose。
        })
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      getCartFormPrams() {
        var paramObj = {
          properties: {},
          params: {}
        };
        $.each($('.product-single__form').serializeArray(), function(_, kv) {
          if (paramObj.properties.hasOwnProperty(kv.name) || paramObj.params.hasOwnProperty(kv.name)) {
            if(kv.name.indexOf('properties') !== -1) {
              paramObj.properties[kv.name] = $.makeArray(paramObj.properties[kv.name]);
              paramObj.properties[kv.name].push(kv.value);
            } else {
              paramObj.params[kv.name] = $.makeArray(paramObj.params[kv.name]);
              paramObj.params[kv.name].push(kv.value);
            }
          }
          else {
            if(kv.name.indexOf('properties') !== -1) {
              paramObj.properties[kv.name] = kv.value;
            } else {
              paramObj.params[kv.name] = kv.value;
            }
          }
        });

        return paramObj
      }

      addToCart(e, id, quantity = 1) {
        this.addButton.classList.add("loading");
        if (typeof id !== 'number' || isNaN(id)) {
          throw new TypeError('Theme Cart: Variant ID must be a number');
        }
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        // 携带 产品推荐 标签
        const actionTag = this.recommendedTag ? { Action: this.recommendedTag } : {}
        const items = [
          {
            id: id,
            quantity: quantity,
            properties: { 
              ...this.getCartFormPrams().properties,
              ...actionTag,
            }
          }
        ]
        shopifyCartAdd({items}).then(r => {
          if(cart && cart.renderContents) {
            cart.renderContents(r);
          } else {
            window.location.href = '/cart';
          }
          setTimeout(() => this.addButton.classList.remove("loading"), 1000)
          // 数据埋码
          gaProductDetailDataLayer({
            "product_spu_name": this.getAttribute('product-title'), //识别页面产品spu标题名称text
            "module": "Parameter", //固定名称Parameter
            "options": this.currentVariant?.title, //主体产品sku文本text。
            "button_name": e.target.innerText, // 按钮名称文本text
          })
        }).catch(err => {
            setTimeout(() => this.addButton.classList.remove("loading"), 1000)
        })
      }

      initStatus() { // fix: js 未加载时候变体切换
        const variant = groupParamsByKey().variant;
        if(!variant) return;

        const target = Array.from(this.variantsButtons).find(item => item.getAttribute('data-id') == variant)

        if(target) {
          const e = {target}
          this.onVariantChange(e)
          // target.getAttribute("disabled") !== null && this.handleShortageClick()
        }
      }
    })
}

